import { nextTick, ref } from 'vue'

/**
 * Unified logic for opening and closing the sharepoint picker dialog.
 * It allows us to avoid rendering the dialog when it's not needed, but also
 * make the <Transition> between opening and closing to work
 */
export const useSharePointPicker = () => {
  const status = ref<'open' | 'transitioning' | 'closed'>('closed')

  const open = () => {
    status.value = 'transitioning'
    nextTick(() => {
      status.value = 'open'
    })
  }

  const close = () => {
    status.value = 'transitioning'
    nextTick(() => {
      status.value = 'closed'
    })
  }

  return {
    status,
    open,
    close,
  }
}
